import { Box, Header, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const DeliveryCardContainer = Box.withConfig({
  width: 'full',
});

export const CardHeading = Header.withConfig({
  variant: 'headerFour',
  color: primitive.$bbqBrown,
  fontSize: 'xl',
  lineHeight: 'sm',
  margin: 0,
  textTransform: 'capitalize',
});

export const CardHeadingContainer = Box.withConfig({
  focusable: true,
  padding: '$4',
});

export const CardText = Text.withConfig({
  variant: 'copyOne',
});
